export default __webpack_public_path__ + "static/media/homeless.a1777257.webp";